import { z } from "zod";
import { TApiCompanyTaskTypeMetadata } from "../common/metadata";
import { TReference } from "../common/relative";
import { TTranslationData } from "../common/translation";
import { TRawChecklistTemplate } from "../checklistTemplate/checklistTemplate";
import { TObjectBaseTDate } from "../base";
import { TDate } from "../common/date";

export const TExternalTaskCreationLinkField = z.enum([
  "checklist",
  "customFields",
  "description",
  "files",
  "placeDescription",
  "title",
]);
export type IExternalTaskCreationLinkField = z.infer<
  typeof TExternalTaskCreationLinkField
>;

export const TExternalTaskCreationLink = z
  .object({
    authenticationTokenID: z.string(),
    companyID: z.string(),
    defaultValues: z
      .object({
        description: z.string().optional(),
        title: z.string().optional(),
      })
      .partial()
      .optional(),
    disableChecklistCheck: z.boolean().nullish(),
    displayName: z.string(),
    emailConfirmationLabels: z
      .object({
        title: TTranslationData,
        description: TTranslationData,
      })
      .partial()
      .optional(),
    properties: z.string().array(),
    taskTypePaths: z.string().array(),
    enabledFields: TExternalTaskCreationLinkField.array(),
    customLabels: z
      .object({
        description: TTranslationData,
        sendButton: TTranslationData,
        title: TTranslationData,
      })
      .partial(),
    checklistTemplateID: z.string().nullish(),
    metadata: z
      .object({
        logoURL: z.string(),
        taskTypes: z.array(TApiCompanyTaskTypeMetadata),
        checklistTemplate: TRawChecklistTemplate,
      })
      .partial()
      .optional(),
  })
  .extend(TObjectBaseTDate.shape);
export type IExternalTaskCreationLink = z.infer<
  typeof TExternalTaskCreationLink
>;

export const TApiExternalTaskCreationLinkData = z.object({
  data: TExternalTaskCreationLink,
});
export type IApiExternalTaskCreationLinkData = z.infer<
  typeof TApiExternalTaskCreationLinkData
>;

export const TRawAuthenticationToken = z
  .object({
    active: z.boolean().default(false),
    claims: z.object({}).optional(),
    dataReference: TReference.optional(),
    lastOpen: TDate.optional(),
    navBarElements: z.array(z.string()).optional(),
    openCount: z.number().default(0),
    openLogsDisabled: z.boolean().default(false),
    redirectURL: z.string().optional(),
    userIDs: z.array(z.string()).optional(),
  })
  .extend(TObjectBaseTDate.shape);
export type IRawAuthenticationToken = z.infer<typeof TRawAuthenticationToken>;

export const TExternalTaskCreationLinkCreationData =
  TExternalTaskCreationLink.omit({
    id: true,
    authenticationTokenID: true,
    archived: true,
    createdBy: true,
    updatedBy: true,
    deletedBy: true,
    deleted: true,
    metadata: true,
  });
export type IExternalTaskCreationLinkCreationData = z.infer<
  typeof TExternalTaskCreationLinkCreationData
>;
